/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './Error.scss';

/**
 * This is the Error component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Error({ children }) {
  return (
    <article className="page error-page">
      <h2>500 {children}</h2>
    </article>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Error.propTypes = {
  children: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Error.defaultProps = {
  children: 'Internal Server Error',
};

export default Error;
